import React, { useCallback, useEffect, useState } from 'react';
import useMediaStreamTrack from '../../hooks/useMediaStreamTrack';
import useVideoContext from '../../hooks/useVideoContext';
import { useTwilioAppState } from '../../state';
import { isMobile, Logger } from '../../utils';

export default function FlipCameraButton(props) {
    const { localTracks } = useVideoContext();
    const [supportsFacingMode, setSupportsFacingMode] = useState(null);
    const videoTrack = localTracks.find(track => track.name.includes('camera'));
    const mediaStreamTrack = useMediaStreamTrack(videoTrack);
    const { settings, twilioSettings } = useTwilioAppState();
    let videoConstraints = null;   
    if (twilioSettings && twilioSettings.settings) {        
        videoConstraints = twilioSettings.settings.videoConstraints ? twilioSettings.settings.videoConstraints : null;
        videoConstraints = twilioSettings.settings.video ? twilioSettings.settings.video : videoConstraints;
    }
    else {
        videoConstraints = settings && settings.videoConstraints ? settings.videoConstraints : null;
        videoConstraints = settings && settings.video ? settings.video : videoConstraints;
    }
    const DEFAULT_VIDEO_CONSTRAINTS = {
        width: videoConstraints && videoConstraints.width ? videoConstraints.width : 1280,
        height: videoConstraints && videoConstraints.height ? videoConstraints.height : 720,
        frameRate: videoConstraints && videoConstraints.frameRate ? videoConstraints.frameRate : 24
    };

    useEffect(() => {
        // The 'supportsFacingMode' variable determines if this component is rendered
        // If 'facingMode' exists, we will set supportsFacingMode to true.
        // However, if facingMode is ever undefined again (when the user unpublishes video), we
        // won't set 'supportsFacingMode' to false. This prevents the icon from briefly
        // disappearing when the user switches their front/rear camera.
        const currentFacingMode = mediaStreamTrack && mediaStreamTrack.getSettings() && mediaStreamTrack.getSettings().facingMode;
        if (currentFacingMode && supportsFacingMode === null) {
            setSupportsFacingMode(true);
        }
    }, [mediaStreamTrack, supportsFacingMode]);

    const toggleFacingMode = useCallback(() => {
        const currentFacingMode = mediaStreamTrack && mediaStreamTrack.getSettings() && mediaStreamTrack.getSettings().facingMode;
        const newFacingMode = currentFacingMode === 'user' ? 'environment' : 'user';
        videoTrack.restart({
            ...DEFAULT_VIDEO_CONSTRAINTS,
            facingMode: newFacingMode
        });
        Logger(`UI.Twilio.Room.FlipCameraButton.Clicked`, new Date(), { currentFacingMode: currentFacingMode, newFacingMode: newFacingMode });
    }, [mediaStreamTrack, videoTrack]);

    return supportsFacingMode && isMobile ? (
        <React.Fragment>
            <button type="button" className={`btn${!videoTrack || props.disabled ? " disabled-style" : ""}`} disabled={!videoTrack || props.disabled} onClick={toggleFacingMode}><span className="icon-flip-camera" /></button>
        </React.Fragment>
    ) : null;
}
